import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DocumentService} from "../../../services/domain/document.service";
import {BasePageComponent} from "../../../base-page.component";
import {
  DocumentiArchivio,
  DocumentiTipo,
  FileArchiveViewModel,
  GetFileTypesViewModel
} from "../../../models/documenti.models";
import {UtilsService} from "../../../services/utils.service";
import {AuthService} from "../../../services/auth.service";

@Component({
  selector: 'app-document-insert',
  templateUrl: './document-insert.component.html',
  styleUrls: ['./document-insert.component.css'],
  providers : [DocumentService]
})
export class DocumentInsertComponent extends BasePageComponent implements OnInit{
  constructor(private documentService : DocumentService) {
    super();

  }
  public lstFileTypes : DocumentiTipo[] = [];
  public fileTypesFilter : GetFileTypesViewModel = new GetFileTypesViewModel();
  public selectedTypeDocument : DocumentiTipo = new DocumentiTipo();
  public saveDocumentRequest : FileArchiveViewModel = new FileArchiveViewModel();
  public file : any;
  @Output() onSaveDocument = new EventEmitter<any>();
  @Input() filtroTipoDocumenti : number = 0;
  ngOnInit(): void {
    this.getFilesTypes();
    this.saveDocumentRequest = new FileArchiveViewModel();
  }

  public getFilesTypes(){
    this.fileTypesFilter.FiltroDocumenti = this.filtroTipoDocumenti;
    this.fileTypesFilter.IdAnagraficaUtenteEnc = AuthService.LoggedUser?.profileIdEnc ?? "";
    this.asyncCall(() => this.documentService.getFilesTypes(this.fileTypesFilter), response => {
      this.lstFileTypes = response.Items || [];
    });
  }
  public changeDocumentType(type : DocumentiTipo){
    this.selectedTypeDocument = type;
  }
  public saveDocument(){

    if(this.file == null){
      return this.showError("Il documento da allegare è obbligatorio");
    }

    if(this.selectedTypeDocument.IdDocumentoTipo == 0){
      return  this.showError("Selezionare una tipologia di documento");
    }

    let ei = "";
    //Gestione delle voci aggiuntive
    for(let i=0; i < this.selectedTypeDocument.ExtraInfoList.length; i++){
      let voce = this.selectedTypeDocument.ExtraInfoList[i];
      if (!isNaN(voce.IdDocumentiTipoExtraInfo) && voce.IdDocumentiTipoExtraInfo > 0) {
        let value;
        if(voce.ExtraInfoType == 'text'){
          value = voce.ExtraInfoValueText;
        }
        else if(voce.ExtraInfoType == 'text-only-letters'){
          value = voce.ExtraInfoValueTextOnlyLetters;

          let regex = /^([^0-9]*)$/;

          if (!regex.test(value)) {
            return this.showError(voce.ExtraInfoLabel + " " + "Può contenere solo lettere");
          }

        }else if(voce.ExtraInfoType == 'select'){
          value = voce.ExtraInfoValueSelect;
        }else if(voce.ExtraInfoType == 'date'){
          value = UtilsService.ConvertDateToTimeZoneIta(voce.ExtraInfoValueDate ?? new Date());
        }else if(voce.ExtraInfoType == 'checkbox'){
          value = voce.ExtraInfoValueCheckBox ? "1" : "0";
        }

        if(voce.IsRequired && (value == null || value.toString().trim() == "" || value == 0))
          return this.showError("Inserire i dati obbligatori");

        ei += '|~|' + voce.IdDocumentiTipoExtraInfo + '#~#' + value;
      }
    }

    this.setDataBeforeSave();
    this.saveDocumentRequest.IdDocumentoTipo = this.selectedTypeDocument.IdDocumentoTipo;
    this.saveDocumentRequest.IdAnagraficaUtenteEnc = AuthService.LoggedUser?.profileIdEnc ?? "";
    this.saveDocumentRequest.ExtraInfo = ei;
    this.loadFileFormData(this.file);
  }
  public onUpload(event : any){
    this.file = event.files[0];
  }

  private loadFileFormData(file : File){
    this.asyncCall(() => {
      let formData = new FormData();
      formData.append("file", file, file.name);
      formData.append("model", JSON.stringify(this.saveDocumentRequest))
      return this.documentService.fileArchive(formData)
    }, () => {
      this.showMessageSaveCompleted();
      this.onSaveDocument.emit();
    });
  }

  private setDataBeforeSave(){
    if(this.saveDocumentRequest.DataDal != null)
      this.saveDocumentRequest.DataDal = UtilsService.ConvertDateToTimeZoneIta(this.saveDocumentRequest.DataDal);

    if(this.saveDocumentRequest.DataAl != null)
      this.saveDocumentRequest.DataAl = UtilsService.ConvertDateToTimeZoneIta(this.saveDocumentRequest.DataAl);
  }

}
